// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__7L8Ut","errorLogs":"EditorFooter_errorLogs__2sXQQ"};